/**
 * Copyright(c) 2024 Magrabi
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 *
 * @author Anoop SS
 */

export const cardValidationConstants = {
  CARD_MIN_LENGTH: 18,
  CARD_MAX_LENGTH: 19,
  CARD_SPACE_LENGTH: 3,
  DATE_FORMAT: "MM/YY",
  IS_DATE: /^(0[1-9]|1[0-2])\/\d{2}$/,
  CVV_LENGTH: 3,
  HAS_TWO_WORDS: /^[A-Za-z]+\s[A-Za-z]+$/,
  FULL_NAME_PATTERN: /^[A-Za-z]+(?:\s+[A-Za-z]+)?\s+[A-Za-z]+$/,
  CVV_PATTERN: /^[0-9]+$/,
};

// Validation RegExp Mapped in EPU-2518
export const validationConstants = {
  sa: {
    phoneNoValidation: /^(5|05)/,
    addressMaxLength: 72,
    characterValidation: /^[A-Za-z\u0600-\u06FF\s]*$/,
    characterMinLength: 2,
  },
  ae: {
    phoneNoValidation: /^(5|05)/,
    addressMaxLength: 72,
    characterValidation: /^[A-Za-z\u0600-\u06FF\s]*$/,
    characterMinLength: 2,
  },
  eg: {
    phoneNoValidation: /^0?(10|11|12|15)/,
    addressMaxLength: 72,
    characterValidation: /^[A-Za-z\u0600-\u06FF\s]*$/,
    characterMinLength: 2,
  },
  qa: {
    phoneNoValidation: /^(3|5|6|7|03|05|06|07)/,
    addressMaxLength: 72,
    characterValidation: /^[A-Za-z\u0600-\u06FF\s]*$/,
    characterMinLength: 2,
  },
  kw: {
    phoneNoValidation: /^(5|6|9|05|06|09)$/,
    addressMaxLength: 72,
    characterValidation: /^[A-Za-z\u0600-\u06FF\s]*$/,
    characterMinLength: 2,
  },
};

export const commonValidationConstants = {
  IS_MAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  IS_VALID_NAME: /^[a-zA-Z\s_']{2,50}$/,
  IS_VALID_ADDRESS: /^[a-zA-Z0-9\s]+$/,
};

export const orderTrackingValidationConstants = {
  IS_ORDER_NUMBER: /^M(AE|SA|EG|QA)(\d{7}|S\d{6})$/,
};
